import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'multiOrder',
  pure: false
})
export class MultiOrderPipe implements PipeTransform {
  transform(array: any[], sortObject = {}): any {
    const sortKeys = Object.keys(sortObject);

    if (!sortKeys.length) {
      return array;
    }

    for (let key in sortObject) {
      sortObject[key] = sortObject[key] === 'desc' || sortObject[key] === -1 ? -1 : (sortObject[key] === 'skip' || sortObject[key] === 0 ? 0 : 1);
    }

    const keySort = (a, b, direction) => {
      direction = direction !== null ? direction : 1;

      if (a === b) {
        return 0;
      }

      // If b > a, multiply by -1 to get the reverse direction.
      return a > b ? direction : -1 * direction;
    };

    return [...array].sort((a, b) => {
      let sorted = 0;
      let index = 0;

      // Loop until sorted (-1 or 1) or until the sort keys have been processed.
      while (sorted === 0 && index < sortKeys.length) {
        const key = sortKeys[index];

        if (key) {
          const direction = sortObject[key];

          sorted = keySort(a[key], b[key], direction);
          index++;
        }
      }

      return sorted;
    });
  }
}
